import { Index1ToMany } from "@logic/lib/utils"
import { atom, selector } from "recoil"

export const areasOfPanelsIndexState = atom<Index1ToMany<string, string>>({
  key: `areasOfPanelsIndex`,
  default: new Index1ToMany<string, string>(),
})

export const areasOfPanelsIndexArrayState = selector({
  key: `areasOfPanelsIndexArray`,
  get: ({ get }) => {
    const areasOfPanelsIndex = get(areasOfPanelsIndexState)
    const areasOfPanels = Array.from(areasOfPanelsIndex.core)

    return areasOfPanels
  },
})
